/**
 * Open a macOS/Chrome-friendly file picker for invoice photos/PDFs.
 *
 * Do NOT set <input accept> or showOpenFilePicker `types` — on macOS those
 * become a broken "Custom"/Images filter that greys out or hides today's
 * Camera/Photos JPG & HEIC files. Validate in JS after the pick instead.
 */

function pickViaHiddenInput() {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    // Intentionally no accept= (see file header).
    input.style.cssText = "position:fixed;left:-9999px;top:0;opacity:0;width:1px;height:1px";
    let settled = false;
    const finish = (file) => {
      if (settled) return;
      settled = true;
      window.removeEventListener("focus", onFocus);
      input.remove();
      resolve(file || null);
    };
    const onFocus = () => {
      // Dialog closed without a change event (Cancel).
      window.setTimeout(() => finish(null), 400);
    };
    input.addEventListener("change", () => {
      finish(input.files?.[0] || null);
    });
    document.body.appendChild(input);
    // focus fires after the native dialog closes
    window.addEventListener("focus", onFocus);
    input.click();
  });
}

/**
 * @returns {Promise<File|null>}
 */
export async function pickInvoiceUploadFile() {
  if (typeof window.showOpenFilePicker === "function") {
    try {
      // No `types` → All Files. That is what makes today's JPGs selectable on Mac.
      const handles = await window.showOpenFilePicker({ multiple: false });
      const handle = handles?.[0];
      if (!handle) return null;
      return await handle.getFile();
    } catch (err) {
      if (err?.name === "AbortError") return null;
      // Permission / API quirks → fall back to <input>.
    }
  }
  return pickViaHiddenInput();
}
